module.exports = __webpack_public_path__ + "static/img/doctor2.a448ebef.webp";